export default __webpack_public_path__ + "static/media/portfolio-60.f41960c1.jpg";